import * as React from "react";
import styled from "styled-components";
import { useCallback } from "react";
import { TableHead, TableHeaderCell } from "views/components/datatable";
import IfInteractive from "views/components/dashboard/IfInteractive";
import EventsTableRow from "views/components/widgets/events/EventsList/EventsTableRow";
import EventsWidgetSortConfig from "views/logic/widgets/events/EventsWidgetSortConfig";
import useEventAttributes from "views/components/widgets/events/hooks/useEventAttributes";
import UnknownAttributeTitle from "views/components/widgets/events/UnknownAttributeTitle";
import AttributeSortIcon from "../../overview-configuration/AttributeSortIcon";
const TableWrapper = styled.div`
  overflow: auto;
`;
const ActionsHeader = styled(TableHeaderCell)`
  && {
    min-width: auto;
    width: 35px;
  }
`;
const EventsTable = ({ events, config, onSortChange, setLoadingState }) => {
  const eventAttributes = useEventAttributes();
  const _onSortChange = useCallback(
    (fieldName, nextDirection) => onSortChange(new EventsWidgetSortConfig(fieldName, nextDirection)),
    [onSortChange]
  );
  return /* @__PURE__ */ React.createElement(TableWrapper, null, /* @__PURE__ */ React.createElement("table", { className: "table table-condensed" }, /* @__PURE__ */ React.createElement(TableHead, null, /* @__PURE__ */ React.createElement("tr", null, config.fields.toArray().map((field) => {
    var _a;
    const eventAttribute = eventAttributes.find(({ attribute }) => field === attribute);
    return /* @__PURE__ */ React.createElement(TableHeaderCell, { key: field }, (_a = eventAttribute == null ? void 0 : eventAttribute.title) != null ? _a : /* @__PURE__ */ React.createElement(UnknownAttributeTitle, null), (eventAttribute == null ? void 0 : eventAttribute.sortable) && /* @__PURE__ */ React.createElement(
      AttributeSortIcon,
      {
        onSortChange: _onSortChange,
        attribute: field,
        attributeTitle: eventAttribute.title,
        activeAttribute: config.sort.field,
        activeDirection: config.sort.direction,
        setLoadingState
      }
    ));
  }), /* @__PURE__ */ React.createElement(IfInteractive, null, /* @__PURE__ */ React.createElement(ActionsHeader, null)))), /* @__PURE__ */ React.createElement("tbody", null, events == null ? void 0 : events.map((event) => /* @__PURE__ */ React.createElement(EventsTableRow, { key: event.id, event, fields: config.fields })))));
};
export default EventsTable;
